export const sanitizeArrayQueryParam = (param?: string | string[] | null) =>
	typeof param === "string" ? param : undefined;
